import { ActiveNavLink } from "components/common/ActiveNavLink";
import { HierarchyContext } from "contexts/HierarchyContext";
import { useContext, useMemo } from "react";
import { getHierarchyBaseUrl } from "../../contexts/hierarchy/getHierarchyBaseUrl";

/**
 * Renders a link to the current hierarchy's parent node (or a corporate link when
 * no hierarchy is selected and a corporate hierarchy exists).
 *
 * @returns A link element to the parent hierarchy when available, otherwise an empty fragment.
 */
export const ParentLink = (): React.ReactElement => {
  const hierarchyContext = useContext(HierarchyContext);

  // Current hierarchy information
  const parent = useMemo(() => {
    return (
      hierarchyContext &&
      hierarchyContext.hierarchy &&
      hierarchyContext.hierarchyNodes.find(
        (h) => h.hierarchyTag === hierarchyContext.hierarchy!.parentTag,
      )
    );
  }, [hierarchyContext]);

  return parent && hierarchyContext?.hierarchy?.level !== "Corporate" ? (
    <>
      <h5>{parent.level}</h5>
      <div className="mb-2">
        <ActiveNavLink
          id="hierarchylinks-parent-link"
          to={`${getHierarchyBaseUrl(parent)}`}
        >
          {parent.name}
        </ActiveNavLink>
        <hr className="mt-3" />
      </div>
    </>
  ) : hierarchyContext?.hierarchy === undefined ? (
    <div>
      <ActiveNavLink
        id="hierarchylinks-corporate"
        to={"/Corporate"}
      >
        Corporate
      </ActiveNavLink>
      <hr className="mt-3" />
    </div>
  ) : (
    <></>
  );
};

ParentLink.displayName = "ParentLink";
